import { getJSON } from 'bv-fetch';

export default ({ sportDimension }) => getJSON(`api/sportsbook/sports/${sportDimension}/competitions`);
